import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=7d4fdbd3&scoped=true"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"
import style0 from "./PlayerCard.vue?vue&type=style&index=0&id=7d4fdbd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4fdbd3",
  null
  
)

export default component.exports